import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, CustomEase);

gsap.set(".js-fade-in", { opacity: 0 });
gsap.set(".js-fade-below", { opacity: 0, bottom: -120 });
gsap.set(
  ".js-products .js-animate, .js-team .js-animate, .js-clients .js-animate",
  { position: "relative", opacity: 0 },
);
gsap.set(".js-work .js-animate", {
  position: "relative",
  opacity: 0,
  bottom: -120,
});
gsap.set(".js-news .js-animate:nth-child(odd)", { opacity: 0, left: -120 });
gsap.set(".js-news .js-animate:nth-child(even)", { opacity: 0, right: -120 });

const addHeaderClass = () => {
  $(".js-header").addClass("header--dark");
};

const removeHeaderClass = () => {
  $(".js-header").removeClass("header--dark");
};

ScrollTrigger.create({
  trigger: ".make-header-transparent",
  start: "top 120%",
  end: "bottom 0",
  onLeave: addHeaderClass,
  onEnterBack: removeHeaderClass,
});

ScrollTrigger.batch(".js-fade-in", {
  onEnter: (batch) =>
    gsap.to(batch, {
      opacity: 1,
      ease: CustomEase.create("custom", "0.19, 1, 0.22, 1"),
      duration: 2,
    }),
  start: "top+=40px bottom-=10%",
});

ScrollTrigger.batch(".js-fade-below", {
  onEnter: (batch) =>
    gsap.to(batch, {
      opacity: 1,
      bottom: 0,
      ease: CustomEase.create("custom", "0.19, 1, 0.22, 1"),
      duration: 2,
    }),
  start: "top+=50 bottom-=10%",
});

ScrollTrigger.batch("section .js-animate, div .js-animate", {
  onEnter: (batch) =>
    gsap.to(batch, {
      opacity: 1,
      ease: CustomEase.create("custom", "0.19, 1, 0.22, 1"),
      duration: 1.3,
      stagger: 0.1,
    }),
  start: "top+=80px bottom-=10%",
});

ScrollTrigger.batch(".js-work .js-animate", {
  onEnter: (batch) =>
    gsap.to(batch, {
      opacity: 1,
      bottom: 0,
      ease: CustomEase.create("custom", "0.19, 1, 0.22, 1"),
      duration: 1.3,
      stagger: 0.22,
    }),
  start: "top+=80px bottom-=10%",
});

ScrollTrigger.batch(".js-news .js-animate:nth-child(odd)", {
  onEnter: (batch) =>
    gsap.to(batch, {
      opacity: 1,
      left: 0,
      ease: CustomEase.create("custom", "0.19, 1, 0.22, 1"),
      duration: 1.3,
    }),
  start: "top+=80px bottom-=10%",
});

ScrollTrigger.batch(".js-news .js-animate:nth-child(even)", {
  onEnter: (batch) =>
    gsap.to(batch, {
      opacity: 1,
      right: 0,
      ease: CustomEase.create("custom", "0.19, 1, 0.22, 1"),
      duration: 1.3,
    }),
  start: "top+=60px bottom-=10%",
});

let loops = gsap.utils.toArray(".js-text-loop").map((line, i) => {
  const links = line.querySelectorAll(".js-text");
  return horizontalLoop(links, {
    repeat: -1,
    speed: 1 + i * 0.5,
    reversed: false,
    paddingRight: parseFloat(gsap.getProperty(links[0], "marginRight", "px")),
  });
});

let currentScroll = 0;
let scrollDirection = 1;

window.addEventListener("scroll", () => {
  let direction = window.pageYOffset > currentScroll ? 1 : -1;
  if (direction !== scrollDirection) {
    loops.forEach((tl) =>
      gsap.to(tl, { timeScale: direction, overwrite: true }),
    );
    scrollDirection = direction;
  }
  currentScroll = window.pageYOffset;

  var distanceFromTop = $(window).scrollTop();

  //>=, not <=
  if (distanceFromTop > 0) {
    $(".js-header").addClass("header--small");
  } else {
    $(".js-header").removeClass("header--small");
  }
});

/*
This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.

Features:
 - Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
 - When each item animates to the left or right enough, it will loop back to the other side
 - Optionally pass in a config object with values like "speed" (default: 1, which travels at roughly 120 pixels per second), paused (boolean),  repeat, reversed, and paddingRight.
 - The returned timeline will have the following methods added to it:
   - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
   - current() - returns the current index (if an animation is in-progress, it reflects the final index)
   - times - an Array of the times on the timeline where each element hits the "starting" spot. There's also a label added accordingly, so "label1" is when the 2nd element reaches the start.
 */
function horizontalLoop(items, config) {
  items = gsap.utils.toArray(items);
  config = config || {};
  let tl = gsap.timeline({
      repeat: config.repeat,
      paused: config.paused,
      defaults: { ease: "none" },
      onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 120),
    }),
    length = items.length,
    startX = items[0].offsetLeft,
    times = [],
    widths = [],
    xPercents = [],
    curIndex = 0,
    pixelsPerSecond = (config.speed || 1) * 120,
    snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 25% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
    totalWidth,
    curX,
    distanceToStart,
    distanceToLoop,
    item,
    i;
  gsap.set(items, {
    // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
    xPercent: (i, el) => {
      let w = (widths[i] = parseFloat(gsap.getProperty(el, "width", "px")));
      xPercents[i] = snap(
        (parseFloat(gsap.getProperty(el, "x", "px")) / w) * 120 +
          gsap.getProperty(el, "xPercent"),
      );
      return xPercents[i];
    },
  });
  gsap.set(items, { x: 0 });
  totalWidth =
    items[length - 1].offsetLeft +
    (xPercents[length - 1] / 120) * widths[length - 1] -
    startX +
    items[length - 1].offsetWidth *
      gsap.getProperty(items[length - 1], "scaleX") +
    (parseFloat(config.paddingRight) || 0);
  for (i = 0; i < length; i++) {
    item = items[i];
    curX = (xPercents[i] / 120) * widths[i];
    distanceToStart = item.offsetLeft + curX - startX;
    distanceToLoop =
      distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
    tl.to(
      item,
      {
        xPercent: snap(((curX - distanceToLoop) / widths[i]) * 120),
        duration: distanceToLoop / pixelsPerSecond,
      },
      0,
    )
      .fromTo(
        item,
        {
          xPercent: snap(
            ((curX - distanceToLoop + totalWidth) / widths[i]) * 120,
          ),
        },
        {
          xPercent: xPercents[i],
          duration:
            (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
          immediateRender: false,
        },
        distanceToLoop / pixelsPerSecond,
      )
      .add("label" + i, distanceToStart / pixelsPerSecond);
    times[i] = distanceToStart / pixelsPerSecond;
  }

  function toIndex(index, vars) {
    vars = vars || {};
    Math.abs(index - curIndex) > length / 2 &&
      (index += index > curIndex ? -length : length); // always go in the shortest direction
    let newIndex = gsap.utils.wrap(0, length, index),
      time = times[newIndex];
    if (time > tl.time() !== index > curIndex) {
      // if we're wrapping the timeline's playhead, make the proper adjustments
      vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
      time += tl.duration() * (index > curIndex ? 1 : -1);
    }
    curIndex = newIndex;
    vars.overwrite = true;
    return tl.tweenTo(time, vars);
  }

  tl.next = (vars) => toIndex(curIndex + 1, vars);
  tl.previous = (vars) => toIndex(curIndex - 1, vars);
  tl.current = () => curIndex;
  tl.toIndex = (index, vars) => toIndex(index, vars);
  tl.times = times;
  if (config.reversed) {
    tl.vars.onReverseComplete();
    tl.reverse();
  }
  return tl;
}
